import { defineStore } from 'pinia'
import { getDataLang, getQuery } from '../helpers/api'

interface IQueryProps {
  showData?: boolean
  category?: string
  headers?: {
    Authorization?: string
  }
  hotel_id?: number
  lang_id?: number
  page_size?: number
  page?: number
}

export interface Facilities {
  facility_title: string
  facility_category?: string | null
  facility_description: any
  facility_image: string | null
  is_placeholder_image?: boolean
  facility_id?: string
  custom_url?: string | null
}

export interface FacilitiesState {
  list: Array<Facilities>
  loading: boolean
}

export const useFacilitiesStore = defineStore('facilities', {
  state: (): FacilitiesState => ({
    list: [],
    loading: false,
  }),
  getters: {
    getList(): FacilitiesState['list'] {
      const params: IQueryProps = getQuery()
      const lang_id = params?.lang_id
      return getDataLang(this.list, 0, 'facility')
    },
  },
  actions: {
    async setList(data: Facilities[]) {
      this.list = data
    },
  },
})
